/* Adds the configured verification label after each Judge.me reviewer name. */
(function () {
  var REVIEWER_NAME_SELECTOR = '#judgeme_product_reviews .jm-reviewer-info__name';
  var BADGE_CLASS = 'blk-jdgm-verified-badge';

  function addVerificationBadges() {
    document.querySelectorAll(REVIEWER_NAME_SELECTOR).forEach(function (name) {
      var container = name.parentElement;
      if (!container || container.querySelector('.' + BADGE_CLASS)) return;

      var badge = document.createElement('span');
      badge.className = BADGE_CLASS;
      badge.setAttribute('aria-label', 'Doğrulanmış satın alma');
      badge.textContent = 'Doğrulanmış';
      container.appendChild(badge);
    });
  }

  document.addEventListener('DOMContentLoaded', addVerificationBadges);
  window.addEventListener('load', addVerificationBadges);

  new MutationObserver(addVerificationBadges).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
